export default __webpack_public_path__ + "static/media/IMG_1068.a45e190b.a45e190b.JPG";